import { render, staticRenderFns } from "./CreateOrEdit.vue?vue&type=template&id=0e8ad28c&scoped=true&"
import script from "./CreateOrEdit.vue?vue&type=script&lang=ts&"
export * from "./CreateOrEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CreateOrEdit.vue?vue&type=style&index=0&id=0e8ad28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8ad28c",
  null
  
)

export default component.exports